var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticStyle:{"margin-bottom":"15px"}},[_vm._v(" "+_vm._s(_vm.libelle)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }